import { useEffect, useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { getAllEstudiantes } from "../../../services/estudiante.service";
import { getAllIdiomasByIdEstudiante } from "../../../services/idioma.service";
import { getAllGruposByIdNivelByModuloByIdIdiomaByIdTurno } from "../../../services/grupo.service";
import { getAllNivelesByIdIdioma } from "../../../services/nivel.service";
import { getAllModulosByIdNivelAndIdIdioma } from "../../../services/modulo.service";
import { axiosEduServer } from "../../../utils/configAxios";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { getAllRegistrosByIdEstudianteIdIdiomaEstado } from "../../../services/registro.service";
import { crearRegistroV2 } from "../../../services/registroV2.service";
import { useLocation, useParams } from "react-router-dom";
import { getAllTurnos } from "../../../services/turno.service";

export const AsignarModuloEstudiantePage = () => {
  const location = useLocation();
  const [estudiantes, setEstudiantes] = useState([]);
  const [username, setUsername] = useState("");
  const [idiomasEstudiante, setIdiomasEstudiante] = useState(null);
  const [grupos, setGrupos] = useState(null);
  const [niveles, setNiveles] = useState(null);
  const [modulos, setModulos] = useState(null);
  const [idNivel, setIdNivel] = useState(null);
  const [idModulo, setIdModulo] = useState(null);
  const [idIdioma, setIdIdioma] = useState(null);
  const [idGrupo, setIdGrupo] = useState(null);
  const [registros, setRegistros] = useState(null);
  const [turnos, setTurnos] = useState(null);
  const [idTurno, setIdTurno] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { idEstudiante } = useParams();
  const { estudiante } = location.state || {};
  const [selectedId, setSelectedId] = useState(null);
  const obtenerEstudiantes = async () => {
    try {
      const estudiantesData = await getAllEstudiantes();
      setEstudiantes(estudiantesData);
    } catch (err) {
      console.log(err);
    }
  };
  const registrarAGrupo = async () => {
    if (!idGrupo) {
      showErrorAlert({ text: "Seleccione un grupo porfavor" });
    } else {
      const fechaActual = new Date();
      const grupoSeleccionado = grupos?.find((g) => g?.idGrupo === idGrupo);
      const totalPrecioGrupo = Number(grupoSeleccionado?.precio ?? grupoSeleccionado?.modulo?.precio ?? 0);

      const dataRegistro = {
        fechaRegistro: fechaActual,
        estado: "Progreso",
        notaFinal: 0,
        totalPrecio: totalPrecioGrupo > 0 ? totalPrecioGrupo : 0,
        idGrupo: idGrupo,
        idEstudiante: idEstudiante,
      };
      const dataRegistroV2 = {
        FechaRegistroV2: fechaActual,
        EstadoV2: "Progreso",
        IdGrupo: idGrupo,
        IdEstudiante: idEstudiante,
        TotalPrecio: totalPrecioGrupo > 0 ? totalPrecioGrupo : 0,
        ProyectoIntegrador: 0,
        ExamenFinalEscrito: 0,
        ExamenFinalOral: 0,
        Tareas: 0,
        Participacion: 0,
        AsistenciaNota: 0,
        NotaFinal: 0,
        NivelModulo: "NO",
      };

      try {
        setLoading(true);
        // Usar ÚNICAMENTE Registro V2 como solicitó el usuario
        await crearRegistroV2(dataRegistroV2);
        
        showAlert({ 
          text: "Estudiante registrado correctamente en el sistema V2." 
        });
      } catch (err) {
        console.error("Error en registro V2: ", err);
        const errorMessage = err?.response?.data?.message || "No se pudo registrar el estudiante en el grupo (Error V2).";
        showErrorAlert({ text: errorMessage });
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    idiomasByIdEstudiante(idEstudiante);
  }, [idEstudiante]);

  const idiomasByIdEstudiante = async (idEstudiante) => {
    try {
      const idiomas = await getAllIdiomasByIdEstudiante(idEstudiante);
      setIdiomasEstudiante(idiomas);
    } catch (err) {
      console.log(err);
    }
  };

  const obtenerGrupos = async () => {
    if (!idNivel) {
      setError("Seleccione un nivel");
    } else if (!idTurno) {
      setError("Seleccione un turno");
    } else if (!idModulo) {
      setError("Seleccione un módulo");
    } else {
      setError(null);
      try {
        const gruposObtenidos = await getAllGruposByIdNivelByModuloByIdIdiomaByIdTurno(
          idNivel,
          idModulo,
          idIdioma,
          idTurno
        );
        
        // Filtrar grupos: solo mostrar aquellos donde fechaFin + 10 días aún no ha pasado
        const fechaActual = new Date();
        const gruposDisponibles = gruposObtenidos.filter((grupo) => {
          // Si no tiene fechaFin, no mostrar el grupo
          if (!grupo.fechaFin) {
            return false;
          }
          
          // Calcular fechaFin + 10 días
          const fechaFinGrupo = new Date(grupo.fechaFin);
          const fechaLimite = new Date(fechaFinGrupo);
          fechaLimite.setDate(fechaLimite.getDate() + 10);
          
          // Mostrar solo si la fecha límite (fechaFin + 10 días) aún no ha pasado
          return fechaLimite >= fechaActual;
        });
        
        setGrupos(gruposDisponibles);
      } catch (err) {
        console.log(err);
      }
    }
  };
  const obtenerRegistros = async (idEstudiante, idIdioma) => {
    try {
      // El GET /registro no incluye grupo.idioma; el backend expone el filtro correcto con Includes.
      const filtrados = await getAllRegistrosByIdEstudianteIdIdiomaEstado(
        idEstudiante,
        idIdioma,
        "Progreso"
      );
      setRegistros(Array.isArray(filtrados) ? filtrados : []);
      console.log("Registros filtrados:", filtrados);
    } catch (err) {
      console.log(err);
      setRegistros([]);
    }
  };

  const handleGetModulosByIdNivelAndIdIdiomaChange = async (idIdioma) => {
    setGrupos(null);
    setSelectedId(idIdioma);
    setIdIdioma(idIdioma);

    await obtenerTurnos();
    await handleGetNivelesByIdIdioma(idIdioma);
    await obtenerRegistros(idEstudiante, idIdioma);
  };

  const handleGetNivelesByIdIdioma = async (idIdioma) => {
    try {
      const nivelesObtenidos = await getAllNivelesByIdIdioma(idIdioma);
      setNiveles(
        nivelesObtenidos?.map((nivel) => ({
          value: nivel?.idNivel,
          label: nivel?.nombre,
        }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleGetAllModulosByIdNivelAndIdIdioma = async (idNivel) => {
    setIdNivel(idNivel);
    setIdModulo(null); // Limpiar módulo seleccionado al cambiar de nivel
    setModulos(null); // Limpiar módulos anteriores
    try {
      const modulosObtenidos = await getAllModulosByIdNivelAndIdIdioma(
        idNivel,
        idIdioma
      );
      // Filtrar duplicados: primero por idModulo, luego por nombre (para evitar módulos con mismo nombre)
      const modulosPorId = modulosObtenidos?.filter((modulo, index, self) =>
        index === self.findIndex((m) => m.idModulo === modulo.idModulo)
      );
      // Filtrar duplicados por nombre, manteniendo solo el primero
      const modulosUnicos = modulosPorId?.filter((modulo, index, self) =>
        index === self.findIndex((m) => m.nombre?.toLowerCase() === modulo.nombre?.toLowerCase())
      );
      setModulos(
        modulosUnicos?.map((modulo) => ({
          value: modulo?.idModulo,
          label: modulo?.nombre,
        }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  const obtenerTurnos = async () => {
    try {
      const turnosObtenidos = await getAllTurnos();
      setTurnos(
        turnosObtenidos?.map((turno) => ({
          value: turno?.idTurno,
          label: turno?.nombre,
        }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <ContenedorPageTemplate objetos={idiomasEstudiante}>
      <div className="fila flex gap-4 justify-between items-center mb-2 w-full"></div>

      {idEstudiante && (
        <section className="flex justify-between">
          <h3 className="mb-auto text-xl font-medium border-b">
            Estudiante:{" "}
            <span className="font-bold text-blue-600">
              {estudiante?.persona?.nombre + " " + estudiante?.persona?.apellido}
            </span>
          </h3>
        </section>
      )}

      {idiomasEstudiante && (
        <section className="flex flex-col gap-3">
          <div className="flex flex-col gap-1 mx-auto">
            <h3 className="text-start">Seleccione un idioma</h3>
            <ul className="grid grid-cols-[repeat(auto-fit,_280px)] max-w-[1200px] justify-center mx-auto gap-6 mb-10">
              {idiomasEstudiante?.map((idioma) => (
                <li
                  key={idioma?.idIdioma}
                  onClick={() =>
                    handleGetModulosByIdNivelAndIdIdiomaChange(idioma?.idIdioma)
                  }
                  className={`capitalize p-3 rounded-lg text-center cursor-pointer ${
                    selectedId === idioma?.idIdioma
                      ? "bg-theme-yellow text-white"
                      : "bg-white"
                  }`}
                >
                  <h3 className="text-xl font-medium p-4">
                    {idioma?.nombre}{" "}
                    <span
                      className={`font-bold ${
                        selectedId === idioma?.idIdioma
                          ? "text-white"
                          : "text-theme-yellow"
                      }`}
                    >
                      {idioma?.sigla}
                    </span>
                  </h3>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-3">
            {niveles && (
              <ul className="flex flex-row items-center gap-1">
                <h3>niveles: </h3>
                {niveles?.map((nivel) => (
                  <li
                    key={nivel?.value}
                    className="capitalize p-1 rounded-lg border text-center cursor-pointer bg-white"
                  >
                    <div className="flex">
                      <input
                        type="radio"
                        id={nivel?.value}
                        name="nivelSelector"
                        onChange={() =>
                          handleGetAllModulosByIdNivelAndIdIdioma(nivel.value)
                        }
                        className="mr-2"
                      />
                      <span>{nivel.label}</span>
                    </div>
                  </li>
                ))}
              </ul>
            )}

            {turnos && (
              <ul className="flex flex-row items-center gap-1">
                <h3>Turnos: </h3>
                {turnos?.map((turno) => (
                  <li
                    key={turno?.value}
                    className="capitalize p-1 rounded-lg border text-center cursor-pointer bg-white"
                  >
                    <div className="flex">
                      <input
                        type="radio"
                        id={turno?.value}
                        name="turnoSelector"
                        onChange={() => setIdTurno(turno.value)}
                        className="mr-2"
                      />
                      <span>{turno.label}</span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {modulos && (
            <div className="flex gap-3 border p-2">
              <h3 className="mb-4">Modulos:</h3>
              <ul className="grid grid-cols-3 gap-2 mt-7">
                {modulos?.map((modulo) => (
                  <li
                    key={modulo?.value}
                    className="capitalize p-1 rounded-lg border text-center cursor-pointer bg-white"
                  >
                    <div className="flex">
                      <input
                        type="radio"
                        id={modulo?.value}
                        name="moduloSelector"
                        className="mr-2"
                        onChange={() => setIdModulo(modulo.value)}
                      />
                      <span>{modulo.label}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      )}
      {idIdioma && (
        <div className="flex flex-col mt-5 relative">
          <button
            onClick={obtenerGrupos}
            className="mx-auto p-3 bg-theme-blue rounded-md text-white"
          >
            Generar grupos
          </button>
          {error && (
            <span className="absolute translate-x-1/2 right-1/2 -bottom-6 text-red-500 text-sm">
              {error}
            </span>
          )}
        </div>
      )}
      <section className="mt-7">
        {grupos !== null && grupos?.length > 0 ? (
          <>
            <div className="grid grid-cols-[repeat(auto-fit,_300px)] max-w-[1200px] justify-center gap-6 mx-auto">
              {grupos.map((grupo) => (
                <div
                  key={grupo?.idGrupo}
                  className="border p-1 rounded transition-colors bg-white hover:bg-slate-100"
                >
                  <input
                    type="radio"
                    id={grupo?.idGrupo}
                    name="grupoSelector"
                    className="mr-2"
                    onChange={() => setIdGrupo(grupo?.idGrupo)}
                  />
                  <h3 className="text-xl font-semibold text-theme-blue text-center mb-1">
                    {grupo?.nombre}
                  </h3>
                  <div>
                    <p className="font-semibold">
                      <span className="font-medium truncate break-words whitespace-normal">
                        {`${grupo?.modulo?.nombre} - ${grupo?.modulo?.sigla} - ${
                          grupo?.turno?.nombre
                        }`}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Docente:{" "}
                      <span className="font-normal truncate break-words whitespace-normal">
                        {grupo?.docente?.nombre} {grupo?.docente?.apellido}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Modalidad:{" "}
                      <span className="font-normal truncate break-words whitespace-normal">
                        {grupo?.modalidad?.nombre}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Cupos:{" "}
                      <span className="font-normal truncate break-words whitespace-normal">
                        {grupo?.cupos}
                      </span>
                    </p>
                    {grupo?.fechaInicio && (
                      <p className="font-semibold">
                        Fecha Inicio:{" "}
                        <span className="font-normal truncate break-words whitespace-normal">
                          {new Date(grupo.fechaInicio).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          })}
                        </span>
                      </p>
                    )}
                    {grupo?.fechaFin && (
                      <p className="font-semibold">
                        Fecha Fin:{" "}
                        <span className="font-normal truncate break-words whitespace-normal">
                          {new Date(grupo.fechaFin).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          })}
                        </span>
                      </p>
                    )}
                  </div>
                  {grupo?.horarios?.length > 0 && (
                    <div>
                      <ul className="flex flex-col">
                        {grupo?.horarios?.map((horario) => (
                          <li key={horario?.idHorario}>
                            {`${horario?.horaInicio} - ${horario?.horaFin} - ${horario?.dia.nombre}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-4 flex">
              <button
                onClick={registrarAGrupo}
                disabled={loading}
                className={`mx-auto p-2 px-4 rounded-md transition-all text-white font-medium text-lg ${
                  loading ? "bg-gray-400 cursor-not-allowed" : "bg-yellow-500 hover:bg-yellow-600"
                }`}
              >
                {loading ? (
                  <div className="flex items-center gap-2">
                    <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                    Procesando...
                  </div>
                ) : (
                  "Registrar"
                )}
              </button>
            </div>
          </>
        ) : (
          grupos?.length === 0 && (
            <div className="text-center text-gray-500 mt-10 bg-white">
              No hay grupos que mostrar.
            </div>
          )
        )}
      </section>
    </ContenedorPageTemplate>
  );
};
